// extracted by mini-css-extract-plugin
export var form = "_g3-0";